<template>
  <div class="lv-state-radio-btn">
    <LvText v-if="title" h6 bold class="mb-8">
      {{ $t(title) }}<span v-if="required" class="lv-state-radio-btn__required">*</span>
    </LvText>
    <RadioButton
      :value="value"
      :row="row"
      :type="type"
      :state="state"
      :disable="disable"
      :isNarrow="isNarrow"
      :radioName="radioName"
      :radioButtonItem="radioButtonItem"
      :rules="rules"
      :textSize="textSize"
      class="lv-state-radio-btn__input-item"
      @input="$_onChangeValue($event)"
      @ll-state="$_onChangeState($event)"
    />
    <WsTextChip001
      v-if="remindText"
      gray
      thin
      small
      leadingIcon="icon-warning"
      :textLabel="remindText"
      class="lv-state-radio-btn__warning"
    />
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    title: {
      type: String,
    },
    radioName: {
      type: String,
    },
    radioButtonItem: {
      type: Object,
      default() {
        return {};
      },
    },
    required: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
    },
    state: {},
    isNarrow: {
      type: Boolean,
      default: false,
    },
    remindText: {
      type: String,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: '',
    },
    textSize: {
      type: String,
      default: 'h4',
    },
  },
  methods: {
    $_onChangeValue(e) {
      if (this.disable) return;
      this.$emit('input', e);
    },
    $_onChangeState($event) {
      if (this.disable) return;
      this.$emit('ll-state', $event);
    },
  },
};
</script>
